import { render, staticRenderFns } from "./Canvas3D.vue?vue&type=template&id=5aaa3da6&"
import script from "./Canvas3D.vue?vue&type=script&lang=js&"
export * from "./Canvas3D.vue?vue&type=script&lang=js&"
import style0 from "./Canvas3D.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports